// extracted by mini-css-extract-plugin
module.exports = {"companyItem__link":"CompanyItem_companyItem__link___Tk_y","companyItem__description":"CompanyItem_companyItem__description__XV8Fo"};